import { Base } from './base';

export class Statistics extends Base {
    Month?: number;
    Day?: number;
    Hour?: number;
    TotalAmount?: number;
    TotalSMS?: number;
    TotalCard?: number;
    TotalNumber?: number;
}
